import DownloadOnAppStoreIcon from '../../assets/icons/download-on-app-store.svg';
import clsx from 'clsx';

export const DownloadOnAppStoreBanner = (props: { onClick: () => void; large?: boolean }) => (
  <img
    className={clsx('store-banner', { 'store-banner--large': props.large })}
    src={DownloadOnAppStoreIcon}
    onClick={props.onClick}
    alt="Download on App Store"
  />
);
